import { Box, CircularProgress } from '@mui/material';

/** The centred spinner shown while a drop is being expanded or read. */
export default function ImportProgressPanel({ label }: { label: string }) {
    return (
        <Box
            sx={{
                flex: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 1.5,
                color: 'text.secondary',
                fontSize: 13,
            }}
        >
            <CircularProgress size={18} />
            {label}
        </Box>
    );
}
